import { render, staticRenderFns } from "./IcoFolderPlus.vue?vue&type=template&id=0b3698ee"
import script from "./IcoFolderPlus.vue?vue&type=script&lang=js"
export * from "./IcoFolderPlus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports